export default __webpack_public_path__ + "static/media/new_dashboard_taskforyou_icon.737b3265.svg";